module.exports = __webpack_public_path__ + "img/Adyen_Corporate_Logo.1d5192f1.svg";